import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "bargraph.icon",
  "use": "bargraph.icon-usage",
  "viewBox": "137 -11509 19 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"137 -11509 19 21\" id=\"bargraph.icon\"><defs><style>#bargraph.icon .cls-1{fill:#c2d4df}</style></defs><g id=\"bargraph.icon_Group_649\" data-name=\"Group 649\" transform=\"translate(89 -12027)\"><path id=\"bargraph.icon_Rectangle_1941\" data-name=\"Rectangle 1941\" class=\"cls-1\" transform=\"translate(48 532)\" d=\"M0 0H4V7H0z\" /><path id=\"bargraph.icon_Rectangle_1944\" data-name=\"Rectangle 1944\" class=\"cls-1\" transform=\"translate(58 528)\" d=\"M0 0H4V11H0z\" /><path id=\"bargraph.icon_Rectangle_1942\" data-name=\"Rectangle 1942\" class=\"cls-1\" transform=\"translate(53 518)\" d=\"M0 0H4V21H0z\" /><path id=\"bargraph.icon_Rectangle_1943\" data-name=\"Rectangle 1943\" class=\"cls-1\" transform=\"translate(63 523)\" d=\"M0 0H4V16H0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bargraph.icon.svg
// module id = 4eOw
// module chunks = 13